import { useState, useEffect, useCallback } from "react";

import dates from "componentsv2/tools/dates";
import proxy from "api/proxy";

function useSheet({ start_date, oc, rate_plan }) {
  const [data, setSheet] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const refetch = useCallback(() => {
    setRefetchTrigger((prev) => prev + 1); // Increment to trigger useEffect
  }, []);

  async function fetchSheet() {
    if (!start_date || !oc || !rate_plan) {
      return null;
    }
    setIsLoading(true);
    // const date_ = dates.fmtDate2Tryton(start_date);
    const date_ = start_date;
    const ctxArgs = {
      model: "hotel.calendar",
      method: "get_sheet",
      args: [
        {
          start_date: date_,
          oc: oc.id,
          rate_plan: rate_plan.id,
        },
      ],
    };
    try {
      const { data: sheetData, error } = await proxy.methodCall(ctxArgs);
      if (error) {
        throw new Error("no_data_available");
      }
      setSheet(sheetData);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchSheet();
  }, [refetchTrigger]);

  return {
    data,
    isLoading,
    error,
    refetch,
  };
}

export { useSheet };
